if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('[data-js-quick-view-trigger]') || this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
				}
			}

		}

		init(){

			this.quickViewModal = null;

			let triggers = this.querySelectorAll('[data-js-quick-view-trigger]');
			if ( triggers.length === 0 ) {
				triggers = this.querySelectorAll('a');
			}

			triggers.forEach(trigger=>{
				trigger.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = trigger;
					}
				});
			});

			triggers.forEach(trigger=>{
				trigger.addEventListener('click', e=>{

					e.preventDefault();
					e.stopPropagation();

					if ( ! this.quickViewModal ) {

						const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							if ( ! quickViewHTML ) {
								target.classList.remove('working');
								window.location.href = target.getAttribute('href');
								return;
							}

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"
								class="modal modal--product"
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true"
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);

						})
						.catch(() => {
							target.classList.remove('working');
							window.location.href = target.getAttribute('href');
						});

				} else {
					this.quickViewModal.show();
				}

				});
			});
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

if ( typeof CrossSellPreview !== 'function' ) {

	class CrossSellPreview extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('[data-js-cross-sell-preview-trigger]') ) {
				this.init();
			}
		}

		initModal(){

			this.previewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.previewModal.hide();
				});
			});

			const mainImg = this.previewModal.querySelector('.cross-sell-preview__main-image-tag');
			const thumbnails = this.previewModal.querySelectorAll('.cross-sell-preview__thumbnail');
			thumbnails.forEach(thumb=>{
				thumb.addEventListener('click', ()=>{
					if ( mainImg && thumb.dataset.imageUrl ) {
						mainImg.src = thumb.dataset.imageUrl;
					}
					thumbnails.forEach(t=>t.classList.remove('is-active'));
					thumb.classList.add('is-active');
				});
			});

			const variantsScript = this.previewModal.querySelector('[data-cross-sell-preview-variants]');
			if ( variantsScript ) {
				try {
					const variants = JSON.parse(variantsScript.textContent);
					const optionSelects = this.previewModal.querySelectorAll('[data-cross-sell-preview-option]');
					const priceEl = this.previewModal.querySelector('[data-cross-sell-preview-price]');

					const updateVariant = ()=>{
						const selected = Array.from(optionSelects).map(s=>s.value);
						const matched = variants.find(v=>{
							return v.options.length === selected.length && v.options.every((opt,i)=>opt === selected[i]);
						});
						if ( matched ) {
							if ( priceEl ) priceEl.textContent = matched.price;
							if ( matched.image && mainImg ) {
								mainImg.src = matched.image;
								thumbnails.forEach(t=>t.classList.remove('is-active'));
							}
						}
					};
					optionSelects.forEach(s=>s.addEventListener('change', updateVariant));
				} catch (err) {
					console.warn('Cross-sell preview: failed to parse variants', err);
				}
			}
		}

		init(){
			this.previewModal = null;
			const triggers = this.querySelectorAll('[data-js-cross-sell-preview-trigger]');

			triggers.forEach(trigger=>{
				trigger.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = trigger;
					}
				});
			});

			triggers.forEach(trigger=>{
				trigger.addEventListener('click', e=>{

					e.preventDefault();
					e.stopPropagation();

					if ( ! this.previewModal ) {

						const target = e.currentTarget;
						target.classList.add('working');

						fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=cross-sell-preview`)
							.then(response => response.text())
							.then(text => {

								const previewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-cross-sell-preview');

								if ( ! previewHTML ) {
									target.classList.remove('working');
									window.location.href = target.getAttribute('href');
									return;
								}

								const container = document.createElement('div');
								container.innerHTML = `<modal-box id="modal-cross-sell-${target.dataset.id}"
									class="modal modal--product modal--cross-sell-preview"
									data-options='{
										"enabled": false,
										"showOnce": false,
										"blockTabNavigation": true
									}'
									tabindex="-1" role="dialog" aria-modal="true"
								>
									<div class="container--medium">
										<div class="modal-content">
											<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
											<div class="cross-sell-preview-mount"></div>
										</div>
									</div>
									<span class="modal-background" data-js-close></span>
								</modal-box>`;

								this.previewModal = container.querySelector('modal-box');
								document.body.appendChild(this.previewModal);
								this.previewModal.querySelector('.cross-sell-preview-mount').innerHTML = previewHTML.outerHTML;

								setTimeout(()=>{
									this.initModal();
								}, 50);

								setTimeout(()=>{
									this.previewModal.show();
									target.classList.remove('working');
								}, 150);

							})
							.catch(() => {
								target.classList.remove('working');
								window.location.href = target.getAttribute('href');
							});

					} else {
						this.previewModal.show();
					}

				});
			});
		}
	}

	if ( typeof customElements.get('cross-sell-preview') == 'undefined' ) {
		customElements.define('cross-sell-preview', CrossSellPreview);
	}

}